export default (theme) => ({
  speedDial: {
    position: 'absolute',
    bottom: 80,
    right: 12,
    zIndex: 'auto',
  },
  staticTooltipLabel: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    boxShadow: 'none',
    background: 'none',
    borderRadius: 'unset',
    whiteSpace: 'nowrap',
    paddingRight: 0,
  },
  backdrop: {
    zIndex: 'auto',
    backgroundColor: 'rgba(237, 237, 237, 0.8)',
  },
  fab: {
    height: 50,
    width: 50,
    backgroundColor: theme.color.black,

    '&:hover': {
      backgroundColor: theme.color.black,
    },
  },
  action: {
    height: 50,
    width: 50,
    '& svg g': {
      fill: theme.color.black,
    },
  },
});
